import { render, staticRenderFns } from "./DashboardUserUM.vue?vue&type=template&id=790e6446&scoped=true&"
import script from "./DashboardUserUM.vue?vue&type=script&lang=js&"
export * from "./DashboardUserUM.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUserUM.vue?vue&type=style&index=0&id=790e6446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790e6446",
  null
  
)

export default component.exports